import axios from 'axios'
import { AuthMFAType, UserInterface } from 'client/Interfaces/UserInterface'

import { getRequestConfig } from './index'

export const cognitoHeaders = {
  'x-amz-user-agent': 'aws-amplify/0.1.x js',
  'content-type': 'application/x-amz-json-1.1',
}

export const cognitoServer = 'https://cognito-idp.eu-central-1.amazonaws.com'

export const isCognitoUser = () => {
  return sessionStorage.getItem('ZervantAccess') !== null
}

export const isCognitoSignup = () => {
  return JSON.parse(atob(sessionStorage.getItem('ZervantSession').split('.')[1])).cognitoSignup === 'true'
}

export const userId = () => {
  return parseInt(JSON.parse(atob(sessionStorage.getItem('ZervantSession').split('.')[1])).userId, 10)
}

export const cognitoCall = async (operation: string, data: any) => {
  return await axios.post(cognitoServer, data, {
    headers: {
      ...cognitoHeaders,
      'x-amz-target': `AWSCognitoIdentityProviderService.${operation}`,
    },
  })
}

export const getCognitoUser = async (): Promise<UserInterface> => {
  const AccessToken = sessionStorage.getItem('ZervantAccess')

  const result = await cognitoCall('GetUser', {
    AccessToken,
  })

  try {
    const data = result.data.UserAttributes
    const id = result.data.Username
    const email = data.find((item) => item.Name === 'email').Value
    const identities = JSON.parse(data.find((el) => el?.Name === 'identities')?.Value || '[]')
    const isIdpUser =
      result.data.Username.includes('Google') ||
      result.data.Username.includes('SignInWithApple') ||
      identities.length > 0
    const mfa = {
      preferred: getMFAType(result.data?.PreferredMfaSetting),
      enabled: getMFATypes(result.data?.UserMFASettingList),
    }
    return { id, email, isIdpUser, identities, mfa }
  } catch (err) {
    console.error(err)
    return err
  }
}

export const sendDeleteAccountEmail = async (locale: string) => {
  await axios.delete('/cognito-api/', { ...getRequestConfig(), data: { locale } })
}

/**
 * @deprecated
 * Ideally we would want to use aws-amplify for this but it cant be bundled with fusebox
 */
export const updateUserAttributes = async (attributes: { [key: string]: string }) => {
  if (!isCognitoUser()) {
    return
  }

  await cognitoCall('UpdateUserAttributes', {
    AccessToken: sessionStorage.getItem('ZervantAccess'),
    UserAttributes: Object.keys(attributes).map((key) => {
      return { Name: key, Value: attributes[key] }
    }),
  })

  await refreshToken()
}

export const changePassword = async (PreviousPassword: string, ProposedPassword: string) => {
  if (!isCognitoUser()) {
    return
  }

  await cognitoCall('ChangePassword', {
    AccessToken: sessionStorage.getItem('ZervantAccess'),
    PreviousPassword,
    ProposedPassword,
  })
}

/**
 * @deprecated
 * Ideally we would want to use aws-amplify for this but it cant be bundled with fusebox
 */
export const refreshToken = async () => {
  if (!isCognitoUser()) {
    return
  }

  const ClientId = JSON.parse(atob(sessionStorage.getItem('ZervantAccess').split('.')[1])).client_id

  const result = await cognitoCall('InitiateAuth', {
    AuthParameters: {
      DEVICE_KEY: null,
      REFRESH_TOKEN: sessionStorage.getItem('ZervantRefresh'),
    },
    AuthFlow: 'REFRESH_TOKEN_AUTH',
    ClientId,
  })

  sessionStorage.setItem('ZervantAccess', result.data.AuthenticationResult.AccessToken)
  sessionStorage.setItem('ZervantSession', result.data.AuthenticationResult.IdToken)
}

export const setUpTOTP = async () => {
  const res = await cognitoCall('AssociateSoftwareToken', {
    AccessToken: sessionStorage.getItem('ZervantAccess'),
  })
  return res.data
}

export const verifyTOTPSetup = async (UserCode: string) => {
  const res = await cognitoCall('VerifySoftwareToken', {
    AccessToken: sessionStorage.getItem('ZervantAccess'),
    UserCode,
  })
  return res.data
}

export const updateMFAPreference = async (status: boolean) => {
  const res = await cognitoCall('SetUserMFAPreference', {
    AccessToken: sessionStorage.getItem('ZervantAccess'),
    SoftwareTokenMfaSettings: {
      Enabled: status,
      PreferredMfa: status,
    },
  })
  return res.data
}

export function getMFAType(type?: string): AuthMFAType | undefined {
  if (type === 'SMS_MFA') {
    return 'SMS'
  }
  if (type === 'SOFTWARE_TOKEN_MFA') {
    return 'TOTP'
  }
}

export function getMFATypes(types?: string[]): AuthMFAType[] | undefined {
  if (!types) {
    return undefined
  }

  return types.map(getMFAType).filter(Boolean) as AuthMFAType[]
}
